import { render, staticRenderFns } from "./ButtonNext.vue?vue&type=template&id=5b1c7016&scoped=true&"
import script from "./ButtonNext.vue?vue&type=script&lang=js&"
export * from "./ButtonNext.vue?vue&type=script&lang=js&"
import style0 from "./ButtonNext.vue?vue&type=style&index=0&id=5b1c7016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c7016",
  null
  
)

component.options.__file = "ButtonNext.vue"
export default component.exports